// myanmar-locale-element-ui.js
export default {
  el: {
    // 常用组件翻译
    pagination: {
      goto: 'သွားပါ',
      pagesize: '/စာမျက်နှာ',
      total: 'စုစုပေါင်း {total}',
      pageClassifier: '',
      page: 'စာမျက်နှာ',
      prev: 'ယခင်စာမျက်နှာ',
      next: 'နောက်စာမျက်နှာ'
    },
    datepicker: {
      now: 'ယခု',
      today: 'ယနေ့',
      cancel: 'ပယ်ဖျက်မည်',
      clear: 'ရှင်းလင်းမည်',
      confirm: 'အတည်ပြုပါ',
      selectDate: 'ရက်စွဲရွေးပါ',
      selectTime: 'အချိန်ရွေးပါ',
      startDate: 'စတင်သည့်ရက်စွဲ',
      endDate: 'ပြီးဆုံးသည့်ရက်စွဲ',
      year: 'နှစ်',
      month1: 'ဇန်နဝါရီ',
      month2: 'ဖေဖော်ဝါရီ',
      month3: 'မတ်',
      month4: 'ဧပြီ',
      month5: 'မေ',
      month6: 'ဇွန်',
      month7: 'ဇူလိုင်',
      month8: 'သြဂုတ်',
      month9: 'စက်တင်ဘာ',
      month10: 'အောက်တိုဘာ',
      month11: 'နိုဝင်ဘာ',
      month12: 'ဒီဇင်ဘာ',
      weeks: {
        sun: 'တနင်္ဂနွေ',
        mon: 'တနင်္လာ',
        tue: 'အင်္ဂါ',
        wed: 'ဗုဒ္ဓဟူး',
        thu: 'ကြာသပတေး',
        fri: 'သောကြာ',
        sat: 'စနေ'
      }
    },
    select: {
      loading: 'တင်နေသည်',
      noMatch: 'ဒေတာမတွေ့ပါ',
      noData: 'ဒေတာမရှိပါ',
      placeholder: 'ရွေးချယ်ပါ'
    },
    messagebox: {
      title: 'သတိပေးချက်',
      confirm: 'အတည်ပြုပါ',
      cancel: 'ပယ်ဖျက်မည်',
      error: 'မှားယွင်းသောထည့်သွင်းမှု'
    },
    upload: {
      deleteTip: 'ဖျက်ရန်ဖျက်ခလုတ်ကိုနှိပ်ပါ',
      delete: 'ဖျက်ပါ',
      preview: 'စစ်ဆေးကြည့်ရှုပါ'
    },
    table: {
      emptyText: 'ဒေတာမရှိပါ'
    }
  }
};